import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=2ee17a42&scoped=true"
import script from "./Criteria.vue?vue&type=script&lang=js"
export * from "./Criteria.vue?vue&type=script&lang=js"
import style0 from "./Criteria.vue?vue&type=style&index=0&id=2ee17a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee17a42",
  null
  
)

export default component.exports